/*********************************
 * 1️⃣ WAIT FOR SECTION (FAST)
 *********************************/
function waitForCdRewards(callback) {

  // 🔥 Immediate check (MOST IMPORTANT)
  const section = document.querySelector("#cd_rewards.cd_single_page");
  if (section) {
    callback(section);
    return;
  }

  // Fallback observer (if section loads later)
  const observer = new MutationObserver(() => {
    const section = document.querySelector("#cd_rewards.cd_single_page");
    if (section) {
      observer.disconnect();
      callback(section);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}


/*********************************
 * 2️⃣ SKELETON
 *********************************/
function showRewardsSkeleton(section) {
  section.innerHTML = `
    <div class="cd_rewards_dashboard">
      <div class="cd_rewards_card cd_skeleton_card"></div>
      <div class="cd_rewards_card cd_skeleton_card"></div>
      <div class="cd_rewards_card cd_skeleton_card"></div>
    </div>
  `;
}


/*********************************
 * 3️⃣ POINTS FETCH (SAFE)
 *********************************/
function getPoints() {
  return new Promise(resolve => {

    const el = document.querySelector(".sweettooth-points-balance");
    if (el && el.innerText.trim()) {
      return resolve(el.innerText.trim());
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(".sweettooth-points-balance");
      if (el && el.innerText.trim()) {
        observer.disconnect();
        resolve(el.innerText.trim());
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    // ⏱ fallback (never block UI)
    setTimeout(() => {
      observer.disconnect();
      resolve("0");
    }, 3000);
  });
}


/*********************************
 * 4️⃣ GLOBAL SECTION REF
 *********************************/
let rewardsSection = null;


/*********************************
 * 5️⃣ SHOW SKELETON ASAP
 *********************************/
waitForCdRewards((section) => {
  rewardsSection = section;

  // 🔥 INSTANT skeleton (NO smile wait)
  showRewardsSkeleton(section);
});


/*********************************
 * 6️⃣ LOAD SMILE DATA
 *********************************/
document.addEventListener("smile-js-initialized", async () => {

  if (!rewardsSection) return;

  try {

    const section = rewardsSection;

    // ⚡ Parallel fetch (fast)
    const [points, rewards, vip] = await Promise.all([
      getPoints(),
      Smile.pointsProducts.get(),
      Smile.customerVipStatus.get()
    ]);

    let vipProgress = 0;
    let currentTier = "None";
    let nextTier = "None";

    if (vip) {
      currentTier = vip.vipTier?.name || "None";
      nextTier = vip.nextVipTier?.name || "None";

      if (vip.progressValue && vip.deltaToNextVipTier) {
        vipProgress =
          (vip.progressValue /
            (vip.progressValue + vip.deltaToNextVipTier)) * 100;
      }
    }

    /*********************************
     * 7️⃣ FINAL HTML (UNCHANGED)
     *********************************/
    let html = `
      <div class="cd_rewards_dashboard">

        <div class="cd_rewards_card cd_points_card">
          <h3>My Rewards Points</h3>
          <div class="cd_points_big">${points || "0"}</div>
        </div>

        <div class="cd_rewards_card">
          <h3>Ways to Redeem</h3>
          <div class="cd_rewards_list">
    `;

    rewards.forEach(r => {
      html += `
        <div class="cd_reward_item">
          <img loading="lazy" src="${r.reward.imageUrl}" />
          <div>
            <p class="cd_reward_title">${r.reward.name}</p>
            <span class="cd_reward_points">${r.pointsPrice} pts</span>
          </div>
        </div>
      `;
    });

    html += `
          </div>
        </div>

        <div class="cd_rewards_card">
          <h3>VIP Status</h3>
          <p>Current Tier: <b>${currentTier}</b></p>
          <p>Next Tier: <b>${nextTier}</b></p>

          <div class="cd_vip_bar">
            <div class="cd_vip_fill" style="width:${vipProgress}%"></div>
          </div>

          <p class="cd_vip_text">${vipProgress.toFixed(1)}% to next tier</p>
        </div>

      </div>
    `;

    // 🔁 Replace skeleton with real UI
    section.innerHTML = html;

  } catch (e) {
    console.error("Smile Load Error:", e);
  }
});
